import { useMediaQuery } from "@mui/material";
import * as rdd from "react-device-detect";
const STORYBOOK_LARGE_MOBILE_WIDTH = 414;
function useIsMobile() {
  const isMobileMediaQuery = useMediaQuery(`@media only screen and (max-width:${STORYBOOK_LARGE_MOBILE_WIDTH}px)`);
  const codeRunningInStorybook = (window == null ? void 0 : window.IS_STORYBOOK) ?? false;
  if (codeRunningInStorybook) {
    return isMobileMediaQuery;
  }
  return rdd.isMobile;
}
export {
  STORYBOOK_LARGE_MOBILE_WIDTH,
  useIsMobile as default
};
//# sourceMappingURL=use-is-mobile.es.js.map
